import React from 'react';
import { IconType } from 'react-icons';
import styled from 'styled-components';

import { ColorVariantEnum, MarginSizeEnum, Text } from '../../atoms/text';
import { theme } from '../../theme';

export interface IDropdownItem {
	label?: string;
	onClick?: (event: React.MouseEvent, value: string | undefined) => void;
	value?: string;
	icon?: IconType;
	isDisabled?: boolean;
	dataUserlane?: string;
	children?: any;
}

const DropdownItemContainer = styled.div<{ isDisabled: boolean }>`
	display: flex;
	align-items: center;
	column-gap: 12px;
	width: auto;
	padding: 8px;
	cursor: pointer;
	background-color: ${({ isDisabled }) =>
		isDisabled ? theme.colors.dropdown.item.background.disabled : theme.colors.dropdown.item.background.default};
	&:hover {
		transition: color 0.2s ease-in-out;
		background-color: ${({ isDisabled }) =>
			isDisabled ? theme.colors.dropdown.item.background.disabled : theme.colors.dropdown.item.background.hover};
	}
`;

export const DropdownItem = ({
	label,
	value,
	isDisabled = false,
	dataUserlane,
	children,
	onClick,
	icon,
}: IDropdownItem) => {
	return (
		<DropdownItemContainer
			onClick={(event: React.MouseEvent) => {
				if (onClick && !isDisabled) {
					return onClick(event, value);
				}
				return null;
			}}
			isDisabled={Boolean(isDisabled)}
			data-userlane={dataUserlane}
		>
			{icon &&
				React.createElement(icon, {
					style: {
						color: isDisabled ? theme.colors.dropdown.icon.color.disabled : theme.colors.dropdown.icon.color.default,
					},
				})}
			{label && (
				<Text.Paragraph
					margin={MarginSizeEnum.NONE}
					colorVariant={isDisabled ? ColorVariantEnum.DISABLED : ColorVariantEnum.DARK}
				>
					{label}
				</Text.Paragraph>
			)}
			{children}
		</DropdownItemContainer>
	);
};
